import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-enquiry-sent',
  templateUrl: './enquiry-sent.component.html',
  styleUrls: ['./enquiry-sent.component.scss']
})
export class EnquirySentComponent {
  constructor(private location: Location) { }

  back() {
    this.location.back();
  }
}